/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type UpsertTravelTimeMutationInput = {
    clientMutationId?: string | null | undefined;
    options: GoalPatchTravelTimeOptionsInput;
    orgId: string;
};
export type GoalPatchTravelTimeOptionsInput = {
    syncToGoogle?: boolean | null | undefined;
};
export type UpsertTravelTimeMutationVariables = {
    input: UpsertTravelTimeMutationInput;
};
export type UpsertTravelTimeMutationResponse = {
    readonly upsertTravelTime: {
        readonly org: {
            readonly id: string;
            readonly userGoals: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly goalId: string;
                        readonly targetUrn: {
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        };
                        readonly otherUrns: ReadonlyArray<{
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        }>;
                        readonly name: string;
                        readonly valueUrn: {
                            readonly id: string;
                            readonly type: UrnType | null;
                            readonly value: string | null;
                        };
                        readonly isDeleted: boolean;
                        readonly options: {
                            readonly syncToGoogle: boolean;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type UpsertTravelTimeMutation = {
    readonly response: UpsertTravelTimeMutationResponse;
    readonly variables: UpsertTravelTimeMutationVariables;
};



/*
mutation UpsertTravelTimeMutation(
  $input: UpsertTravelTimeMutationInput!
) {
  upsertTravelTime(input: $input) {
    org {
      id
      userGoals(first: 1000000) {
        edges {
          node {
            id
            goalId
            targetUrn {
              id
              type
              value
            }
            otherUrns {
              id
              type
              value
            }
            name
            valueUrn {
              id
              type
              value
            }
            isDeleted
            options {
              syncToGoogle
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UpsertTravelTimeMutationPayload",
            "kind": "LinkedField",
            "name": "upsertTravelTime",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Org",
                    "kind": "LinkedField",
                    "name": "org",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1000000
                                }
                            ],
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "userGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Goal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "goalId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Urn",
                                                    "kind": "LinkedField",
                                                    "name": "targetUrn",
                                                    "plural": false,
                                                    "selections": (v2 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Urn",
                                                    "kind": "LinkedField",
                                                    "name": "otherUrns",
                                                    "plural": true,
                                                    "selections": (v2 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Urn",
                                                    "kind": "LinkedField",
                                                    "name": "valueUrn",
                                                    "plural": false,
                                                    "selections": (v2 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isDeleted",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "GoalOptions",
                                                    "kind": "LinkedField",
                                                    "name": "options",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "syncToGoogle",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": "userGoals(first:1000000)"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpsertTravelTimeMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpsertTravelTimeMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "f3db8df5fa2c9e16ad6088d8c8678ada",
            "id": null,
            "metadata": {},
            "name": "UpsertTravelTimeMutation",
            "operationKind": "mutation",
            "text": "mutation UpsertTravelTimeMutation(\n  $input: UpsertTravelTimeMutationInput!\n) {\n  upsertTravelTime(input: $input) {\n    org {\n      id\n      userGoals(first: 1000000) {\n        edges {\n          node {\n            id\n            goalId\n            targetUrn {\n              id\n              type\n              value\n            }\n            otherUrns {\n              id\n              type\n              value\n            }\n            name\n            valueUrn {\n              id\n              type\n              value\n            }\n            isDeleted\n            options {\n              syncToGoogle\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b290ec44dfd1a3e48c62913f7523c900';
export default node;
